import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface ExternalRedirectProps {
  url: string;
  preserveQueryParams?: boolean;
}

export default function ExternalRedirect({ url, preserveQueryParams = true }: ExternalRedirectProps) {
  const location = useLocation();

  useEffect(() => {
    const redirectUrl = preserveQueryParams && location.search
      ? `${url}${location.search}`
      : url;

    window.location.href = redirectUrl;
  }, [url, location.search, preserveQueryParams]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <p className="text-gray-600">Redirecting to our shop...</p>
      </div>
    </div>
  );
}
